import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import Container from '@mui/material/Container'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'

import TerminologyForm from '../requests/TerminologyForm'

import { RequestStyle } from '../styles'
import { initializeTags } from '../../reducers/tagsReducers'
import { setErrorNotification } from '../../reducers/notificationReducer'
import { PAGES } from '../navigation/routes'
import { LivingGlossaryGuidelines } from '../dropdowns/guideline.js'

const RequestTerm = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const user = useSelector(state => state.user)

    useEffect(() => {
        // Wait for user state to load before making auth decisions
        if (!user) {
            return
        }

        if (user.anon) {
            dispatch(setErrorNotification('You must be logged in to view this page'))
            navigate(PAGES.home.path)
            return
        }

        dispatch(initializeTags())
    }, [user, dispatch, navigate])

    return (
        <Container {...RequestStyle.container.props} sx={RequestStyle.container.style}>
            {(user && (user.staff || user.terminology_admin)) ?
                <Typography {...RequestStyle.title} gutterBottom>
                    Create Term
                </Typography> :
                <Typography {...RequestStyle.title} gutterBottom>
                    Request Term
                </Typography>
            }
            {(user && (user.staff || user.terminology_admin)) && 
                <Box sx={RequestStyle.para}>
                    <Typography {...RequestStyle.paraText} gutterBottom>
                        As you are an admin user, please be aware that any term you create here will be automatically approved and visible to all.
                    </Typography>
                </Box>
            }
            <LivingGlossaryGuidelines />
            <Box sx={{ marginTop: '20px' }}>
                { user && !user.anon && 
                    <TerminologyForm user={user} />
                }
            </Box>
        </Container>
    )
}

export default RequestTerm
